"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _yup = require("yup");
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("../../../../../../bus/ui/selectors");
var _actions = require("../../../../store/actions");
var _selectors2 = require("../../../../store/selectors");
var _actions2 = require("./store/actions");
var _constants = require("./constants");
var _helpers = require("./helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var withFormProps = function withFormProps(Component) {
  var WithBasketsEditFormProps = function WithBasketsEditFormProps(props) {
    var basketID = props.basketID;
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
      t = _useTranslation.t;
    var ui = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getUI)(state, {
        key: (0, _helpers.getUIKey)(basketID)
      });
    });
    var editBasket = (0, _react.useCallback)(function (values) {
      dispatch((0, _actions2.prepare2UpdateBasket)(basketID, values));
    }, [dispatch, basketID]);
    var onChangeDiscount = (0, _react.useCallback)(function (discount) {
      dispatch((0, _actions.mergeTempEditBasketData)(basketID, {
        discount: discount
      }));
    }, [dispatch, basketID]);
    var onChangeMargin = (0, _react.useCallback)(function (margin) {
      dispatch((0, _actions.mergeTempEditBasketData)(basketID, {
        margin: margin
      }));
    }, [dispatch, basketID]);
    var onChangeShowPriceWithMargin = (0, _react.useCallback)(function (showPriceWithMargin) {
      dispatch((0, _actions.mergeTempEditBasketData)(basketID, {
        showPriceWithMargin: showPriceWithMargin
      }));
    }, [dispatch, basketID]);
    var onChangeRound = (0, _react.useCallback)(function (round) {
      dispatch((0, _actions.mergeTempEditBasketData)(basketID, {
        round: round
      }));
    }, [dispatch, basketID]);
    (0, _react.useEffect)(function () {
      return function () {
        dispatch((0, _actions.removeTempEditBasketData)(basketID));
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return (0, _selectors2.getBasketById)(state, {
          basketID: basketID
        });
      }),
      comment = _useSelector.comment,
      _useSelector$discount = _useSelector.discount,
      discount = _useSelector$discount === void 0 ? '' : _useSelector$discount,
      title = _useSelector.title,
      _useSelector$margin = _useSelector.margin,
      margin = _useSelector$margin === void 0 ? '' : _useSelector$margin,
      showPriceWithMargin = _useSelector.showPriceWithMargin,
      locale = _useSelector.locale,
      template = _useSelector.template,
      round = _useSelector.round,
      offersReviewsLink = _useSelector.offersReviewsLink,
      rating = _useSelector.rating;
    return /*#__PURE__*/_react.default.createElement(_formik.Formik, {
      enableReinitialize: true,
      initialValues: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _constants.FORM_FIELDS.TITLE, title), _constants.FORM_FIELDS.COMMENT, comment), _constants.FORM_FIELDS.TEMPLATE, template || _constants.DEFAULT_TEMPLATE), _constants.FORM_FIELDS.DISCOUNT, String(discount)), _constants.FORM_FIELDS.MARGIN, String(margin)), _constants.FORM_FIELDS.SHOW_PRICE_WITH_MARGIN, showPriceWithMargin), _constants.FORM_FIELDS.LOCALE, locale), _constants.FORM_FIELDS.ROUND, round), _constants.FORM_FIELDS.OFFERS_REVIEWS_LINK, offersReviewsLink), _constants.FORM_FIELDS.RATING, rating),
      validationSchema: (0, _yup.object)().shape(_defineProperty({}, _constants.FORM_FIELDS.TITLE, (0, _yup.string)().required(t('EMPTY_BASKET_TITLE_ERROR')))),
      onSubmit: editBasket
    }, function (_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        initialValues = _ref2.initialValues,
        values = _ref2.values,
        touched = _ref2.touched;
      return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
        isActiveSubmitButton: !R.equals(initialValues, values),
        isShowSuccessMessage: ui.completed && !ui.error && R.equals(initialValues, values) && R.isEmpty(touched),
        loading: ui.loading,
        onChangeMargin: onChangeMargin,
        onSubmit: handleSubmit,
        onChangeDiscount: onChangeDiscount,
        onChangeShowPriceWithMargin: onChangeShowPriceWithMargin,
        onChangeRound: onChangeRound
      }));
    });
  };
  return WithBasketsEditFormProps;
};
var _default = exports.default = withFormProps;